import {isNullOrUndefined} from "../../../services/Validator";

export default function LevelAMetaDataSubthemeNameText({name}) {
    // Used in LevelAMetaData to display LevelA Subtheme name

    // BUILD
    if (isNullOrUndefined(name))
        return null
    return (
        <div className={"flex justify-start items-center space-x-[4px]"}>
            <span className={""}>
                {" - "}
            </span>
            <span className={"pl-[2px] pr-[4px]"}>
                {name}
            </span>
        </div>
    );
}